import request from '@/utils/axios.js'

// 获取音频分组
export function getAudioPacket(data) {
  return request({
    url: '/audioGroup',
    method: 'get',
    params: data
  })
}


// 获取音频分组（无分页）
export function getAudioPacketNoPaging(data) {
  return request({
    url: '/audioGroup/list',
    method: 'get',
    params: data
  })
}

// 添加音频分组
export function addAudioPacket(data) {
  return request({
    url: '/audioGroup',
    method: 'post',
    data
  })
}

// 修改音频分组
export function updateAudioPacket(data) {
  return request({
    url: `/audioGroup/${data.id}`,
    method: 'put',
    data: {
      name: data.name
    }
  })
}

// 删除音频分组
export function deleteAudioPacket(data) {
  return request({
    url: `/audioGroup/${data.id}`,
    method: 'delete',
  })
}

// 直播设置详情
export function getSettingDetails(data) {
  return request({
    url: '/liveSetting',
    method: 'get',
    params: data
  })
}

// 直播设置修改
export function settingModification(data) {
  return request({
    url: '/liveSetting',
    method: 'put',
    data
  })
}

// 音频素材列表
export function getAudioList(data) {
  return request({
    url: '/audio',
    method: 'get',
    params: data
  })
}

// 添加音频
export function addAudio(data) {
  return request({
    url: '/audio',
    method: 'post',
    data
  })
}

// 编辑音频
export function editAudio(data) {
  return request({
    url: `/audio/${data.id}`,
    method: 'put',
    data: data.data
  })
}


// 删除音频
export function deleteAudio(id) {
  return request({
    url: `/audio/${id}`,
    method: 'delete',
  })
}

// 获取sts
export function getSts() {
  return request({
    url: '/oss/getSts',
    method: 'get',
  })
}

// 获取财务日志列表
export function getFinanceLog(data) {
  return request({
    url: '/financeLog',
    method: 'get',
    params: data
  })
}